export const hashtag = '#PineapplePodcastStyle'
export const MAX_SCREEN_WIDTH = 960
